var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tx instanceof _vm.Withdrawal
    ? _c("withdrawal", {
        attrs: { tx: _vm.tx },
        on: {
          refetchList: function($event) {
            return _vm.$emit("refetchList")
          }
        }
      })
    : _vm.tx instanceof _vm.Issuance
    ? _c("issuance", { attrs: { tx: _vm.tx } })
    : _vm.tx instanceof _vm.Transfer
    ? _c("transfer", { attrs: { tx: _vm.tx } })
    : _vm.tx instanceof _vm.TransferV2
    ? _c("transfer-v2", { attrs: { tx: _vm.tx } })
    : _vm.tx instanceof _vm.Match
    ? _c("match", { attrs: { tx: _vm.tx } })
    : _vm.tx instanceof _vm.InvoiceAssetHistory
    ? _c("invoice", { attrs: { tx: _vm.tx } })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c1d3168", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c1d3168","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/history/index/History.TxDetails.vue
// module id = 0fYX
// module chunks = 1